import mineralMattescreen from "./mineral-mattescreen.png";
import resettingPowder from "./resetting-powder.png";
import protectint from "./protectint.png";
import unseenSunscreen from "./unseen-sunscreen.png";
import glowscreen from "./glowscreen.png";
import niacinamide from "./niacinamide.png";
import cetaphilMoisturizer from "./cetaphil-moisturizer.png";
import larocheToleriane from "./laroche-toleriane.png";
import ceraveMoisturizer from "./cerave-moisturizer.png";
import playEverydayLotion from "./play-everyday-lotion.png";
import dewscreen from "./dewscreen.png";
import superscreen from "./superscreen.png";
import playAntioxidantMist from "./play-antioxidant-mist.png";

export const productImages = {
  mineralMattescreen,
  resettingPowder,
  protectint,
  unseenSunscreen,
  glowscreen,
  niacinamide,
  cetaphilMoisturizer,
  larocheToleriane,
  ceraveMoisturizer,
  playEverydayLotion,
  dewscreen,
  superscreen,
  playAntioxidantMist,
};

// Map ASINs and brand keywords to product images
const asinImageMap: Record<string, string> = {
  // Hero Supergoop products
  "B09JVX2NNR": mineralMattescreen,
  "B01LTI2ENW": mineralMattescreen,
  "B0854MSAL1": resettingPowder,
  "B0ENVVMF71": protectint,
  "B0DPM3B043": unseenSunscreen,
  // AppDataContext hero ASINs
  "B07ABC12345": unseenSunscreen,
  "B08XY267890": glowscreen,
  "B09KL345678": niacinamide,
};

const brandImageMap: Record<string, string> = {
  "Cetaphil": cetaphilMoisturizer,
  "La Roche-Posay": larocheToleriane,
  "CeraVe": ceraveMoisturizer,
  "Supergoop!": mineralMattescreen,
  "The Ordinary": niacinamide,
};

/**
 * Resolves a product image URL. If the product has a known ASIN or brand,
 * returns the generated product image. Otherwise returns the original URL.
 */
export function resolveProductImage(imageUrl: string, asin?: string, brand?: string): string {
  if (asin && asinImageMap[asin]) {
    return asinImageMap[asin];
  }
  if (brand && brandImageMap[brand]) {
    return brandImageMap[brand];
  }
  if (imageUrl === "/placeholder.svg") {
    // Return a default product image for unknown products
    return cetaphilMoisturizer;
  }
  return imageUrl;
}

export {
  mineralMattescreen,
  resettingPowder,
  protectint,
  unseenSunscreen,
  glowscreen,
  niacinamide,
  cetaphilMoisturizer,
  larocheToleriane,
  ceraveMoisturizer,
  playEverydayLotion,
  dewscreen,
  superscreen,
  playAntioxidantMist,
};
